<template>
	<div>
		<div class="card-body pd-0">
			<div data-label="Approvals Table">
				<table id="approvals-table" class="table">
					<thead>
						<tr>
							<th class="wd-10p">Type</th>
							<th class="wd-15p">Date</th>
							<th class="wd-40p">Description</th>
							<th class="wd-15p">Status</th>
							<th class="wd-20p"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(approval, index) in approvals" :key="index">
							<td>
								<div class="media justify-content-center align-items-center py-1"
									v-html="approvalIcon(approval.type, approval.status)"></div>
							</td>
							<td>{{ approval.created_at | toDate('LL') }}</td>
							<td>
								<div class="media align-items-center">
									<div class="media-body">
										<p class="tx-medium mg-b-0">{{ approvalType(approval.type, approval.data) }}</p>
										<p class="tx-12 mg-b-0 tx-color-03">Created by {{
											inputterName(approval.inputter) }}</p>
									</div>
								</div>
							</td>
							<td class="text-center">
								<div class="py-2 w-75 w-sm-100" v-html="approvalStatus(approval.status)"></div>
							</td>
							<td class="justify-content-center">
								<div class="py-2">
									<router-link class="btn btn-sm btn-white shadow-sm d-block"
										:to="{ name: 'approvals.view', params: { 'request': approval.id } }">
										<i data-feather="eye" class="wd-10 mg-r-5"></i> View
									</router-link>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>


</template>

<style>
	table.dataTable tbody td {
		line-height: 1.8;
	}

	.wal-70 {
		width: 70%;
	}

	@media (max-width: 426px) {
		.w-sm-100{
			width: 100% !important;
		}
	}
</style>

<script>
export default {
	mounted() {
		$("#approvals-table").DataTable({
			responsive: true,
			columnDefs: [
				{
					targets: 0,
					className: "text-center",
					orderable: false,
				},
				{
					targets: 1,
					className: "text-center"
				},
				{
					targets: 3,
					className: "text-center"
				},
				{
					targets: -1,
					orderable: false,
					className: "text-center"
				}
			],
			language: {
				searchPlaceholder: "Search...",
				sSearch: "",
				lengthMenu: "_MENU_",
				emptyTable: "No approvals available."
			},
			initComplete: (settings, json) => {
				feather.replace();
			},
			drawCallback: settings => {
				feather.replace();
			}
		});
	},
	computed: {},
	methods: {
		inputterName(inputter) {
			const other_names = inputter.additional_names
				? `${inputter.additional_names}`
				: " ";

			return inputter.first_name + other_names + inputter.last_name;
		}
	},
	props: ["approvals"]
};
</script>